// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"RoomHeader_mainContainer__2VP8r","headerBtn":"RoomHeader_headerBtn__3sKGG","MuiButton-root":"RoomHeader_MuiButton-root__1h0DY"};